import { FETCH_SUMMARY_PERIODS_LOADING, FETCH_SUMMARY_PERIODS } from "../actions/types";


const infoSummaryPeriodsReducer =  (state = {}, action) => {
    switch (action.type) {
        case FETCH_SUMMARY_PERIODS_LOADING:
            return {...state, 'loading': true };
        case FETCH_SUMMARY_PERIODS:
            return { ...state,  [action.internalId]: action.payload ,'loading': false}
        default:
            return state;
    }
};

export default infoSummaryPeriodsReducer;